import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { Typo } from "../../typography";
export const Wrapper = styled.div `
  background-color: ${({ theme }) => theme.colors.white};

  hr {
    margin: 0.5rem 0;
  }
`;
export const StyledMenuBar = styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background-color: white;
  justify-content: flex-start;
  position: absolute;
  ${({ containerHeight }) => `height: calc(${containerHeight}px - 3.75rem)`};
  right: 0;
  ${({ isDrawerOpen }) => (isDrawerOpen ? "right: 0" : "right: -100%")};
  transition: 300ms ease-in-out;
  transition-property: right;
  top: 3.75rem;
  bottom: 0;
  overflow-y: auto;
  > div:first-child:not(:last-child) {
    margin-bottom: 1.5rem;
    padding: 0 1rem;
    button {
      transform: translateX(-0.75rem);
    }
  }

  ul li {
    background-color: transparent;
  }

  @media ${({ theme }) => theme.device.medium} {
    width: 21rem;
    max-width: 21rem;
    ${({ isDrawerOpen }) => (isDrawerOpen ? "right: 0" : "right: -210rem")};

    justify-content: space-between;
    overflow-y: scroll;
    > div:first-child:not(:last-child) {
      padding: 0 1.5rem;
    }
  }
`;
export const TransparentLayer = styled.div `
  position: absolute;
  top: 3.75rem;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
  transition: 300ms ease-in-out;
  transition-property: opacity;
  background-color: rgba(${({ theme }) => theme.colors.transparentBlack}, 0.5);
  ${({ isDrawerOpen }) => (isDrawerOpen ? "opacity : 1" : "")};
  pointer-events: ${({ isDrawerOpen }) => (isDrawerOpen ? "initial" : "none")};
  height: calc(100vh - 3.75rem);

  @media ${({ theme }) => theme.device.large} {
    pointer-events: none;
  }
`;
export const StyledNav = styled.nav `
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;
export const TabsWrapper = styled.div ``;
export const StyledTypo = styled((p) => _jsx(Typo, Object.assign({}, p))) `
  color: ${({ theme }) => theme.colors.grey13};
  padding-left: 0.5rem;
  margin-top: 1.5rem;
  margin-bottom: 0;
`;
